<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" :class="{scrolled: scrolled}"/>
    <div class="loadingFull" v-if="loading"></div>
    <NotFound v-else-if="!event"/>
    <InvitationPage :event="event" v-else/>
    <Footer/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import InvitationPage from '@/components/InvitationPage.vue';
import Footer from '@/components/Footer.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  name: 'home',
  components: {
    Header,
    InvitationPage,
    Footer,
    NotFound,
  },
  data() {
    return {
      loading: true,
      scrolled: false,
      event: null,
    };
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    const { code } = this.$route.params;

    /**
     * Validate language
     *
     */
    if (!this.$route.params.lang) {
      let langCode = window.navigator.userLanguage || window.navigator.language;
      langCode = (langCode.indexOf('id') >= 0) ? 'id' : 'en';
      const countryCode = (langCode === 'id') ? 'id' : 'us';
      window.location.href = `/${langCode}-${countryCode}/invitation/${code}`;
    }

    /**
     * Get event page
     *
     */
    this.$http.get(this.$config.uri(`invitation/detail/${code}`)).then((r) => {
      this.loading = false;
      this.event = r.data.status === 200 ? r.data.data : null;
    });
  },
};
</script>

<style scoped lang="scss">
</style>
